<template>
  <div ref="container" @click="onClick">
    <div class="truncate text-theme" v-if="!isImage">{{ fileName }}</div>
    <div v-else>
      <img :src="fileUrl" width="120" @load="onLoad">
    </div>
    <div class="cancel-file cursor-pointer" v-if="!view" @click.stop="removeFile">
      <span class="cancel-icon"></span>
    </div>
  </div>
</template>

<script>
import { imageFiles,convertDownloadUrl,getFileStream } from 'dygc'
import { previewImage } from '@/assets/js/preview-image'

export default {
  name: 'FileItem',
  props: {
    file: {
      type: Object,
      default: () => ({})
    },
    view: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fileName() {
      return this.convertFileName(this.file.name)
    },
    fileUrl(){
      return convertDownloadUrl(this.file.url)
    },
    isImage() {
      const suffix = this.file.url.split('.').pop()
      return imageFiles.includes('.' + suffix.toLowerCase())
    }
  },
  methods: {
    onClick(){
      if(!this.view) return
      if(this.isImage) {
        return
      }
      let strs = this.fileName.split('.')
      strs.pop()
      window.open(getFileStream(this.file.url,strs.join('.')))
    },
    onLoad(){
      previewImage(this.$refs.container)
    },
    convertFileName(filename = '') {
      filename = decodeURIComponent(filename)
      const splits = filename.split('/')
      filename = splits.pop()
      if (filename.indexOf('_') > -1) {
        let [, ...names] = filename.split('_')
        filename = names.join('_')
      }
      return filename
    },
    removeFile() {
      this.$emit('remove')
    }
  }
}
</script>

<style scoped>

</style>